import {useEffect, useState} from 'react'
import {Modal} from 'rsuite'
import Pagination from 'rsuite/Pagination'
import Table from 'rsuite/Table'
import {service} from '../redux/service'

type Visitor = {id: number; ipAddress: string | null; userAgent: string | null; visitedAt: string | null}

type Props = {
  auction: {id: string; name: string}
  handleClose: () => void
}

// Legacy auction_notice/_visitors.php: public detail views of one auction (backend setting auctionVisitorLog).
const AuctionVisitorsModal = ({auction, handleClose}: Props) => {
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [rows, setRows] = useState<Visitor[]>([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    service
      .getAuctionVisitors(auction.id, {page, limit})
      .then((res) => {
        setRows(res?.data?.data?.visitor ?? [])
        setTotal(res?.data?.data?.meta?.total ?? 0)
      })
      .catch(() => setRows([]))
      .finally(() => setLoading(false))
  }, [auction.id, page, limit])

  return (
    <Modal open={true} onClose={handleClose} size='lg' backdrop='static' enforceFocus={false}>
      <Modal.Header>
        <Modal.Title>Visitors: {auction.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table data={rows} loading={loading} autoHeight wordWrap='break-word' locale={{emptyMessage: 'No visitors yet.'}}>
          <Table.Column width={60}>
            <Table.HeaderCell>S.N.</Table.HeaderCell>
            <Table.Cell>{(_row: any, i?: number) => (page - 1) * limit + (i ?? 0) + 1}</Table.Cell>
          </Table.Column>
          <Table.Column width={140}>
            <Table.HeaderCell>IP Address</Table.HeaderCell>
            <Table.Cell dataKey='ipAddress' />
          </Table.Column>
          <Table.Column flexGrow={1}>
            <Table.HeaderCell>User Agent</Table.HeaderCell>
            <Table.Cell dataKey='userAgent' />
          </Table.Column>
          <Table.Column width={170}>
            <Table.HeaderCell>Visited On</Table.HeaderCell>
            <Table.Cell dataKey='visitedAt' />
          </Table.Column>
        </Table>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          className='mt-5'
          maxButtons={5}
          size='sm'
          layout={['total', '-', 'limit', '|', 'pager']}
          total={total}
          limitOptions={[10, 20, 50, 100]}
          limit={limit}
          activePage={page}
          onChangePage={setPage}
          onChangeLimit={(value) => {
            setLimit(value)
            setPage(1)
          }}
        />
      </Modal.Body>
    </Modal>
  )
}

export default AuctionVisitorsModal
